import React from 'react';
import { useMsal } from '@azure/msal-react';

const MsalWrapper = (WrappedComponent) => {
  return function MsalHOC(props) {
    const { instance, accounts, inProgress } = useMsal();

    return (
      <WrappedComponent
        instance={instance}
        accounts={accounts}
        inProgress={inProgress}
        {...props}
      />
    );
  };
};

export default MsalWrapper;
